(function () {
    'use strict';

    function initBreadcrumbs(container) {
        var inner = container.querySelector('.breadcrumbs__inner');
        var current = container.querySelector('.breadcrumbs__current');
        var fullText = current ? current.textContent.trim() : '';
        var characters = Array.from(fullText);
        var breadcrumbLinks = inner
            ? Array.prototype.slice.call(inner.querySelectorAll('a.breadcrumbs__label'))
            : [];
        var middleItems = breadcrumbLinks.slice(1, -1).map(function (element) {
            return {
                element: element,
                text: element.textContent.trim(),
                title: element.getAttribute('title'),
                ariaLabel: element.getAttribute('aria-label')
            };
        });
        var frame = null;

        if (!inner || !current || !fullText) {
            return;
        }

        function setText(length) {
            current.textContent = characters.slice(0, length).join('').replace(/\s+$/, '') + '…';
        }

        function restoreMiddleItems() {
            middleItems.forEach(function (item) {
                item.element.textContent = item.text;

                if (item.title === null) {
                    item.element.removeAttribute('title');
                } else {
                    item.element.setAttribute('title', item.title);
                }

                if (item.ariaLabel === null) {
                    item.element.removeAttribute('aria-label');
                } else {
                    item.element.setAttribute('aria-label', item.ariaLabel);
                }
            });
        }

        function collapseLongestMiddleItem() {
            var itemToCollapse = middleItems.reduce(function (longestItem, item) {
                if (!longestItem) return item;

                return item.element.getBoundingClientRect().width
                    > longestItem.element.getBoundingClientRect().width
                    ? item
                    : longestItem;
            }, null);

            if (!itemToCollapse) return;

            itemToCollapse.element.textContent = '...';
            itemToCollapse.element.setAttribute('title', itemToCollapse.text);
            itemToCollapse.element.setAttribute('aria-label', itemToCollapse.text);
        }

        function updateBreadcrumbs() {
            var low = 0;
            var high = characters.length;
            var fittingLength = 0;

            current.textContent = fullText;
            current.removeAttribute('title');
            current.removeAttribute('aria-label');
            restoreMiddleItems();

            if (inner.scrollWidth <= inner.clientWidth + 1) {
                return;
            }

            collapseLongestMiddleItem();

            if (inner.scrollWidth <= inner.clientWidth + 1) {
                return;
            }

            while (low <= high) {
                var middle = Math.floor((low + high) / 2);

                setText(middle);

                if (inner.scrollWidth <= inner.clientWidth + 1) {
                    fittingLength = middle;
                    low = middle + 1;
                } else {
                    high = middle - 1;
                }
            }

            setText(fittingLength);
            current.setAttribute('title', fullText);
            current.setAttribute('aria-label', fullText);
        }

        function requestUpdate() {
            if (frame !== null) {
                window.cancelAnimationFrame(frame);
            }

            frame = window.requestAnimationFrame(function () {
                frame = null;
                updateBreadcrumbs();
            });
        }

        window.addEventListener('resize', requestUpdate);

        if ('ResizeObserver' in window) {
            new ResizeObserver(requestUpdate).observe(inner);
        }

        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(requestUpdate);
        }

        updateBreadcrumbs();
    }

    function init() {
        document.querySelectorAll('.breadcrumbs-container').forEach(initBreadcrumbs);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
}());
